export const GET_ALL_LOOKUPS_SUCCESS =
  'CBRE-FLOW-UM/GET_ALL_LOOKUPS_SUCCESS';
export const GET_ALL_LOOKUPS_FAILURE =
  'CBRE-FLOW-UM/GET_ALL_LOOKUPS_FAILURE';
export const MODULE = 'cbre-pjm-admin-root-details';
